export const ERROR_LIST: Record<number, string> = {
  8: 'Price quote expired', // max input condition violated
  9: 'Price quote expired', // min output condition violated
  11: 'Price quote expired', // Slippage tolerance condition violated
  36: 'Protocol is paused',
  48: 'Chainlink prices outdated',
  44: 'Amount too large',
  57: 'Amount too large',
  58: 'Amount too large',
}

/**
 * uint256 internal constant REENTRY         = 0;
 * uint256 internal constant PASSED_DEADLINE = 1;
 * uint256 internal constant LIMIT_IN        = 2;
 * uint256 internal constant LIMIT_OUT       = 3;
 * uint256 internal constant BAD_LIMIT_IN    = 4;
 * uint256 internal constant NEGATIVE_PRICE  = 5;
 * uint256 internal constant FAILED_CALL     = 6;
 */
export const PROXY_ERROR_LIST: Record<number, string> = {
  1: 'Transaction expired', // max input condition violated
  2: 'Price quote expired',
  3: 'Price quote expired',
  4: 'Not enough native token',
  5: 'Quotation error',
  6: '0x swaps failed',
}
